export default "__VITE_ASSET__2za4m79v__"